'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaHandPointerO = function FaHandPointerO(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.8 2.9q-1.2 0-2 0.8t-0.9 2v20l-3.3-4.5q-1-1.2-2.4-1.2-1.2 0-2 0.8t-0.8 2.1q0 0.9 0.5 1.7l8.6 11.4q0.9 1.1 2.3 1.1h16q0.5 0 0.9-0.3t0.5-0.7l2.1-8.2q0.5-2.2 0.5-4.4v-4.8q0-0.9-0.6-1.6t-1.6-0.7-1.5 0.7-0.6 1.5h-0.7v-1.4q0-1.1-0.7-1.8t-1.8-0.8q-1 0-1.8 0.8t-0.7 1.7v1.5h-0.7v-2q0-1.3-0.9-2.1t-2-0.9q-1.2 0-2 0.8t-0.8 2v2.2h-0.8v-12.8q0-1.2-0.8-2.1t-2-0.8z m0-2.9q2.4 0 4 1.7t1.7 4.1v5q0.5-0.1 0.7-0.1 2.2 0 3.9 1.6 1-0.5 2.2-0.5 2.5 0 4.1 1.9 0.6-0.1 1.2-0.1 2.1 0 3.6 1.5t1.4 3.6v4.8q0 2.6-0.6 5l-2 8.3q-0.4 1.4-1.6 2.3t-2.6 0.9h-16q-1.4 0-2.6-0.6t-2-1.7l-8.6-11.4q-1.1-1.5-1.1-3.4 0-2.4 1.7-4.1t4-1.7q1.6 0 2.9 0.8v-12.2q0-2.4 1.6-4t4.1-1.7z m2.8 31.4v-8.5h-0.7v8.5h0.7z m5.8 0v-8.5h-0.8v8.5h0.8z m5.7 0v-8.5h-0.7v8.5h0.7z' })
        )
    );
};

exports.default = FaHandPointerO;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/hand-pointer-o.js
// module id = 814
// module chunks = 168707334958949